<template>
    <!--底部导航-->
    <section>
        <div class="bottomNavigation nark" v-if="kiss!=0">
        <ul class="bottomNavigation-navigation nrk">
            <li v-for="(item,index) in navigations" :key="index">
                <h1>{{item.name}}</h1>
                <router-link :to="{name:son.url}" v-for="(son,indexs) in item.son" :key="indexs">
                    {{son.name}}
                </router-link>
            </li>
            <li>
                <h1>联系我们</h1>
                <a>电&emsp;&emsp;话：{{Main.mobile}}</a>
                <a>传&emsp;&emsp;真：0086-431-85645312</a>
                <a>邮&emsp;&emsp;箱：jlpdi111@sina.com</a>
                <a>地&emsp;&emsp;址：{{Main.address}}</a>
            </li>
        </ul>
        </div>
        <!--底部版权-->
        <div class="copyright">
            <div class="copyright-title nrk">
                <p>版权所有：{{Main.bq}}<span>电话:{{Main.mobile}}</span></p>
                <p>地址：{{Main.address}}<span>备案:{{Main.ba}}</span></p>
                <p>技术支持：{{Main.skill}}</p>
                <img :src="Http+Main.logo" class="copyright-rwm">
            </div>
        </div>
    </section>
    
</template>

<script>
import{mapState} from'vuex';
export default {
    props:['kiss'],
    computed:{
        ...mapState({
            Main:state=>state.share.Main,
            Http:state=>state.share.Http,
            navigation(state){
                let navigation=state.share.navigation
                return navigation
                
            },
            navigations(){
                let naviga=this.navigation;
                naviga=naviga.slice(1)
                naviga=naviga.slice(0,-1);
                return naviga
            }
        })
    },
    methods: {
        shifts(e){
            e=e.shift()
            return e
        }
    },
}
</script>
<style>
    .bottomNavigation{
        width: 100%;
        overflow: hidden;
        padding: 50px 0 30px 0;
        background-color: #f7f7f7;
        margin-top: 36px;
    }
    .bottomNavigation-navigation{
        margin: 0 auto;
        overflow: hidden;
        padding:0 1px;
    }
    .bottomNavigation-navigation li{
        float: left;
        width: 179px;
        border-left: 1px #dcdcdc solid;
        padding-left: 20px;
        position: relative;
    }
    .bottomNavigation-navigation li h1{
        margin-bottom: 40px;
        font-size: 16px;
        color: #333;
        font-weight: normal;
    }
    .bottomNavigation-navigation li a{
        display: block;
        padding-bottom: 10px;
        color: #666;
        font-size: 12px;
    }
    .bottomNavigation-navigation li a:hover{
        color: #0019a7;
    }
    .bottomNavigation-navigation li::after{
        content:"";
        width: 3px;
        height: 30px;
        background-color: #0019a7;
        left: -2px;
        top: 0;
        position: absolute;
    
    }
    .bottomNavigation-navigation li:last-child{
        width: 478px;
    }
    .copyright{
        width: 100%;
        overflow: hidden;
        padding: 27px 0;
        background-image: linear-gradient(to top, #002892, #005cb6);
        position: relative;
        z-index: 99;
    }
    .copyright-title{
        margin: 0 auto;
        position: relative;
    }
    .copyright-title p{
        color: #fff;
        margin-top: 12px;
        font-size: 12px;
        text-align: center;
    }
    .copyright-title span{
        margin-left: 12px;
    }
    .copyright-title img{
        position: absolute;
        top: -20px;
        right: 150px;
        width: 100px;
        height: 100px;

    }
    @media (max-width: 768px){
        .copyright{
            margin-top: 20px;
        }
        .bottomNavigation{
            display: none;
        }
        .copyright-title img{
            position:unset;
            margin:0 auto;
            display: block;
            margin-top: 20px;
        }
        .copyright-title span{
            display: block;
            margin: 0 auto;
            margin-top: 12px;
        }
    }
</style>